const data = {
  "EAF": [
    {
      "country": "KE",
      "title": "Women workers at high risk from automation",
      "link": "https://fullerproject.org/story/women-workers-at-high-risk-from-automation/",
      "reporter": "Allan Olingo & Muktadir Rashid, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-1242604646.jpg",
      "photoCredit": "Photo by Billy Mutai/Anadolu Agency via Getty Images",
      "summary": [
        "30,000 women working in Kenya’s tea plantations have lost their jobs to automation in the past five years, labor leaders say. These tea workers represent a broader global trend: women are more likely than men to lose their jobs due to automation."
      ]
    },
    {
      "country": "KE",
      "title": "‘Women bear the biggest brunt of climate change,’ says climate scientist Susan Chomba",
      "link": "https://fullerproject.org/story/women-bear-the-biggest-brunt-of-climate-change-says-climate-scientist-susan-chomba/",
      "reporter": "Neha Wadekar, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/DSC03535.jpg",
      "photoCredit": "Fredryk Lerneryd/The Fuller Project",
      "summary": [
        "Roughly 12 percent of the world’s top climate scientists are women and fewer than one percent are from Africa – a continent likely to be one of the hardest hit by climate change.",
        "Susan Chomba defies those statistics as a woman in an influential position at one of the world’s best-known environmental organizations.",
        "Her success comes from her ability to connect with and listen to those most affected and often most unheard – local farmers, community elders and, notably, women."
      ]
    },
    {
      "country": "KE",
      "title": "Reporter’s Notebook: Kenya’s tea sector is automating fast, pushing women workers into a financial crisis",
      "link": "https://fullerproject.org/story/reporters-notebook-kenyas-tea-sector-is-automating-fast-pushing-women-workers-into-a-financial-crisis/",
      "reporter": "Allan Olingo",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-1242604895.jpg",
      "photoCredit": "Photo by Billy Mutai/Anadolu Agency via Getty Images",
      "summary": [
        "30,000 women have lost their jobs in Kenya’s tea sector in the last five years due to automation — now they’re struggling to get by."
      ]
    },
    {
      "country": "KE",
      "title": "‘We want accountability’ – As femicide deaths surge, Kenyan women demand an end to violence",
      "link": "https://fullerproject.org/story/as-femicide-deaths-surge-kenyan-women-demand-an-end-to-violence/",
      "reporter": "Allan Olingo",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-1957434408.jpg",
      "photoCredit": "Photo by TONY KARUMBA/AFP via Getty Images",
      "summary": [
        "After thousands of demonstrators took to the streets to protest the spike in gender-based murder, calls to protect women grow."
      ]
    },
    {
      "country": "SO",
      "title": "This is ours” – Somaliland women smell success as frankincense business takes off",
      "link": "https://fullerproject.org/story/somaliland-women-smell-success-as-frankincense-business-takes-off/",
      "reporter": "Rachel Fobar, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Fatima-and-Nimo-in-the-sorting-house-Photo-handout-from-Beeyo-Maal-Cooperative.jpg",
      "photoCredit": "Photo handout from Beeyo Maal Cooperative",
      "summary": [
        "Wellness brand doTERRA says it’s suspending work with a Somaliland frankincense supplier after a two-year investigation uncovered evidence women workers were underpaid and abused."
      ]
    },
    {
      "country": "SD",
      "title": "The women who helped bring down Sudan’s dictator hoped it would end discrimination against them. Instead, they’re fighting for their lives.",
      "link": "https://fullerproject.org/story/the-women-who-helped-bring-down-sudans-dictator-are-fighting-for-their-lives/",
      "reporter": "Neha Wadekar, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-1258482593.jpg",
      "photoCredit": "Photo by AFP via Getty Images",
      "summary": [
        "Sudanese women at the forefront of the grassroots movement that toppled Sudanese dictator Omar al-Bashir hoped they’d secure equality and a seat at the negotiating table; instead, the fundamental military leaders who took over sidelined them and started a war that systemically targets women with sexual violence."
      ]
    }
  ],
  "WAF": [
    {
      "country": "SL",
      "title": "Do Gender Quotas in Elections Work?",
      "link": "https://fullerproject.org/story/do-gender-quotas-in-elections-work/",
      "reporter": "Umaru Fofana & Maher Sattar, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Gender-Quotas.jpeg",
      "photoCredit": "Photo by JOHN WESSELS/AFP via Getty Image",
      "summary": [
        "Gender quotas for national elections have been criticized by opponents on the grounds that they are unmeritocratic, undemocratic, and nepotistic. Today, there's a growing consensus among experts that they \"work.\""
      ]
    },
    {
      "country": "NG",
      "title": "African fashion is booming. It could create millions of jobs for women.",
      "link": "https://fullerproject.org/story/african-fashion-is-booming-it-could-create-millions-of-jobs-for-women/",
      "reporter": "Louise Donovan",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-1756858106.jpg",
      "photoCredit": "Photo by BENSON IBEABUCHI/AFP via Getty Images",
      "summary": [
        "African fashion is booming as the continent’s middle class expands. It could create millions of jobs for women."
      ]
    }
  ],
  "SAF": [],
  "us": [
    {
      "country": "US",
      "title": "The Carolina Abortion Fund: A lifeline for Southern women, struggles to meet demand amid state bans",
      "link": "https://fullerproject.org/story/the-carolina-abortion-fund-a-lifeline-for-southern-women-struggles-to-meet-demand-amid-state-bans/",
      "reporter": "Erica Hensley, in partnership with Reckon",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/KristyKelly_08.jpg",
      "photoCredit": "Photo by Nancy Pierce",
      "summary": [
        "State bans are forcing more women to travel far from home to get abortions, creating unprecedented demand for local abortion funds that help women, often parents living in poverty, cover expenses."
      ]
    },
    {
      "country": "US",
      "title": "Anxious wait for working mothers as last of California’s pandemic relief set to expire",
      "link": "https://fullerproject.org/story/anxious-wait-for-working-mothers-as-last-of-californias-pandemic-relief-set-to-expire/",
      "reporter": "Courtney E. Martin, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Anxious-Wait.jpg",
      "photoCredit": "llustration by Susie Ang for The Guardian",
      "summary": [
        "Government stimulus payments, unemployment insurance, childcare subsidies and rent relief helped millions avoid poverty and homelessness during the pandemic, but now those funds are drying up and women of color are struggling."
      ]
    },
    {
      "country": "US",
      "title": "“There’s no support” — Undocumented and unemployed in pandemic-era California",
      "link": "https://fullerproject.org/story/undocumented-and-unemployed-in-pandemic-era-california/",
      "reporter": "Yusra Farzan, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Undocumented-Immigrants_The-Guardian_SA3-scaled-1.jpg",
      "photoCredit": "llustration by Susie Ang for The Guardian",
      "summary": [
        "Undocumented workers contribute billions of dollars to California’s economy and pay millions into the state's unemployment fund. Yet when they lose their jobs, they can’t claim benefits they helped fund. Reporter Yusra Farzan tells the stories of two of these working women."
      ]
    },
    {
      "country": "US",
      "title": "“Living on the Edge: how the “benefits cliff” holds women back",
      "link": "https://fullerproject.org/story/living-on-the-edge-how-the-benefits-cliff-holds-women-back/",
      "reporter": "Bunny McFadden, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Benefits-Cliff.jpeg",
      "photoCredit": "llustration by Susie Ang for The Guardian",
      "summary": [
        "Not every promotion is a good one. Workers who rely on government assistance for food, housing and healthcare can lose those benefits if they get a raise. It’s called the “benefits cliff” and it mostly affects American women."
      ]
    },
    {
      "country": "US",
      "title": "Sex Matters: Medical Research Overlooks Women",
      "link": "https://fullerproject.org/story/sex-matters-medical-research-overlooks-women/",
      "reporter": "Maggie Fox, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Medical-research.jpeg",
      "photoCredit": "Marko Geber/Getty Images",
      "summary": [
        "Medical researchers still usually take a one-size-fits-all approach in testing new treatments.",
        "Women often respond differently than men to drugs and other therapies, but doctors aren’t finding out because researchers don’t look for the disparities.",
        "Congress has tried to change this, but a 30-year-old law hasn’t had the desired effect. The Biden administration just launched a new initiative to combat the inequalities."
      ]
    },
    {
      "country": "US",
      "title": "Will California crack down on cash apps that trap women in debt?",
      "link": "https://fullerproject.org/story/will-california-crack-down-on-cash-apps-that-trap-women-in-debt/",
      "reporter": "Aaron Glantz & Monica Campbell, in partnership with Los Angeles Times",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Cash-Apps.jpeg",
      "photoCredit": "Jim Cooke / Los Angeles Times",
      "summary": [
        "Earned Wage Access apps like Earnin, Dave Banking, Daily Pay, and Brigit offer fast cash to strapped workers. They also target young women – who often end up in debt."
      ]
    },
    {
      "country": "US",
      "title": "She escaped her husband’s physical violence – but economic ties kept them connected for years",
      "link": "https://fullerproject.org/story/she-escaped-her-husbands-physical-violence-but-economic-ties-kept-them-connected-for-years/",
      "reporter": "Carly Stern, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/susie-illo.jpg",
      "photoCredit": "Illustration by Susie Ang for The Guardian",
      "summary": [
        "Economic abuse can easily be hidden behind a facade of wealth, and lots of people don’t know how to recognize or acknowledge this form of abuse.",
        "Banks need to understand what this means so they can identify financial abuse and better support their customers when it happens.",
        "Banks and legislators in other countries are far ahead of the US when it comes to providing training and support for survivors."
      ]
    },
    {
      "country": "US",
      "title": "Silicon Valley VCs Invest Almost Exclusively in Companies Founded by Men. Could a new California law change that?",
      "link": "https://fullerproject.org/story/silicon-valley-vcs-invest-almost-exclusively-in-companies-founded-by-men-could-a-new-california-law-change-that/",
      "reporter": "Hanisha Harjani, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-sb10068540e-001.jpg",
      "photoCredit": "Williams+Hirakawa/Getty Images",
      "summary": [
        "Though third-party sources have shown that funding disproportionately goes to white men, currently there exists no official data on how venture capital firms invest their money. If signed by Governor Gavin Newsom, a new California law could compel VC firms operating in the state to disclose the demographics of the founders they fund. Civil rights groups say if detailed demographic data becomes available because of this law, venture capital firms could be taken to court for discriminatory practices."
      ]
    },
    {
      "country": "US",
      "title": "Can the Climate Tech Revolution Avoid Leaving Women Behind?",
      "link": "https://fullerproject.org/story/can-the-climate-tech-revolution-avoid-leaving-women-behind/",
      "reporter": "Katharine Gammon, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/AV-Rourke-6-scaled-1.jpg",
      "photoCredit": "Courtesy GRID Alternatives",
      "summary": [
        "69% of jobs in green energy are held by men – a level virtually unchanged for the last 15 years. Fuller Project contributor Katherine Gammon examines why women are so underrepresented in solar and wind and what’s being done about it."
      ]
    },
    {
      "country": "US",
      "title": "Homelessness Spikes Among California Women",
      "link": "https://fullerproject.org/story/homelessness-spikes-among-california-women/",
      "reporter": "Sarah McClure in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-1687925130.jpg",
      "photoCredit": "Jay L. Clendenin / Los Angeles Times via Getty Images",
      "summary": [
        "In California, where the number of homeless people has surged, the number of homeless women has also grown. There were 58,000 unhoused women in the Golden State in 2022 — almost twice as many as second-placed New York, and an increase of 50 percent over the previous eight years, according to data from the federal Department of Housing and Urban Development.",
        "This rise poses a test for state policymakers, who must cope with an increase in groups that face unique challenges, such as domestic violence survivors, pregnant women, and women with children.",
        "Last year, Gov. Gavin Newsom signed a bill that proponents say makes California a national leader in addressing the needs of unhoused women. But while the number of homeless women in other big states, including Florida and New York, is on the decline, the problem in California keeps getting worse."
      ]
    },
    {
      "country": "US",
      "title": "How motherhood spurred one New Yorker to take on the fossil fuel industry",
      "link": "https://fullerproject.org/story/how-motherhood-spurred-one-new-yorker-to-take-on-the-fossil-fuel-industry/",
      "reporter": "Yessenia Funes, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Marlena-Fontes-07.jpeg",
      "photoCredit": "Ismail Ferdous for The Fuller Project",
      "summary": [
        "Motherhood opened Marlena Fontes’ eyes to the dangers posed by climate change and spurred her to co-found Climate Families NYC with fellow moms who also wanted to make a difference. The group seeks to help families find a space to act and give their kids a sense of agency over a crisis that can seem overwhelming. Now she’s using skills honed in her work as a labor organizer to take on the fossil fuel industry."
      ]
    },
    {
      "country": "US",
      "title": "A veteran legal researcher wants us to re-imagine how courts treat domestic violence cases",
      "link": "https://fullerproject.org/story/veteran-legal-researcher-wants-us-to-re-imagine-how-courts-treat-domestic-violence-cases/",
      "reporter": "Maher Sattar",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Witthaya-Prasongsin_Getty-Images.jpeg",
      "photoCredit": "Witthaya Prasongsin/Getty Images",
      "summary": [
        "Law professor Leigh Goodmark tells us why she changed her views on how courts should handle domestic violence."
      ]
    },
    {
      "country": "US",
      "title": "Author Cat Bohannon on post-Roe America, asteroids and the medical “male norm”",
      "link": "https://fullerproject.org/story/the-myth-busting-book-putting-women-at-the-center-of-evolution/",
      "reporter": "Erica Hensley",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Photo-credit_-Stefano-Giovannini.jpg",
      "photoCredit": "Stefano Giovannini",
      "summary": [
        "'Eve' flips the narrative of evolution by spotlighting how the female body drove human biology."
      ]
    },
    {
      "country": "US",
      "title": "Two U.S. states crack down on cash apps that trap women in debt",
      "link": "https://fullerproject.org/story/two-u-s-states-crack-down-on-cash-apps-that-trap-women-in-debt/",
      "reporter": "Aaron Glantz",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Suwaree-Tangbovornpichet_Getty-Images.jpeg",
      "photoCredit": "Suwaree Tangbovornpichet/Getty Images",
      "summary": [
        "Since our report on the Earned Wage Access industry last May, Maryland and Connecticut have stepped in to regulate cash apps."
      ]
    },
    {
      "country": "US",
      "title": "States owe Historically Black Colleges and Universities billions, disproportionately harming Black women",
      "link": "https://fullerproject.org/story/states-owe-historically-black-colleges-and-universities-billions-disproportionately-harming-black-women/",
      "reporter": "Erica Hensley",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/caf042cd-e740-8733-66d0-d583e74e6bf5.jpg",
      "photoCredit": "Photo by Naville J. Oubre/Southern University and A&M College via Getty Images",
      "summary": [
        "Historically Black Colleges and Universities are owed billions of dollars, despite being beacons of Black excellence across the U.S."
      ]
    }
  ],
  "SAM": [
    {
      "country": "SV",
      "title": "'Cornered on All Sides'",
      "link": "https://fullerproject.org/story/cornered-on-all-sides/",
      "reporter": "Anna-Catherine Brigida, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Photo-by-Roque-Alvarenga_APHOTOGRAFIA_Getty-Images.jpg",
      "photoCredit": "Photo by Roque Alvarenga/APHOTOGRAFIA/Getty Images",
      "summary": [
        "It's a pivotal moment for the women of El Salvador as Latin America’s human rights court considers whether the country’s total ban on abortion — with no exceptions for rape, incest or the health of the mother — violates a woman's right to life."
      ]
    },
    {
      "country": "PE",
      "title": "Peru has its first female president — but feminists aren’t celebrating",
      "link": "https://fullerproject.org/story/peru-has-its-first-female-president-feminists-arent-celebrating/",
      "reporter": "Simeon Tegel, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Photo-by-Michael-Bednar_Getty-Images.jpg",
      "photoCredit": "Photo by Michael Bednar/Getty Images",
      "summary": [
        "Far from being carried on the back of a feminist wave, Dina Boluarte’s rise to power came at a particularly challenging time for gender rights in Peru.",
        "Boluarte aligned herself with conservative factions who had been pushing an anti-women political agenda.",
        "This agenda included the controversial passage of a law allowing parents to block gender-focused education on wage disparities and femicide."
      ]
    }
  ],
  "EAS": [
    {
      "country": "KR",
      "title": "South Korea’s crackdown on false accusations has “chilling effect” on rape survivors",
      "link": "https://fullerproject.org/story/south-koreas-crackdown-on-false-accusations-has-chilling-effect-on-rape-survivors/",
      "reporter": "Hawon Jung, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-930020262.jpg",
      "photoCredit": "Photo by Seung-il Ryu/NurPhoto via Getty Images",
      "summary": [
        "Women in South Korea have fought vigorously against gender violence, whether sexual harassment at work or tech-based sexual abuse like spycam porn -- in what is arguably the most powerful case of #MeToo movement in Asia.",
        "Many spoke out in defiance of relentless bullying, public shaming, or even a barrage of criminal accusations and defamation lawsuits often brought up by their abusers, a practice called “revenge accusations/lawsuits.",
        "Now they worry the modicum of progress made in recent years are under threat as efforts to curb gender violence stall under the rightwing government that took power last year on an openly antifeminist platform."
      ]
    },
    {
      "country": "KR",
      "title": "Dozens of American servicewomen have died after suffering sexual harassment or abuse. A new series from The War Horse asks why",
      "link": "https://fullerproject.org/story/dozens-of-american-servicewomen-have-died-after-suffering-sexual-harassment-or-abuse-a-new-series-from-the-war-horse-asks-why/",
      "reporter": "Thomas J. Brennan",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Illustration-by-Sarah-Flores-for-The-War-Horse.jpeg",
      "photoCredit": "Illustration by Sarah Flores for The War Horse",
      "summary": [
        "A new series from The War Horse examines noncombat deaths of women in the U.S. military, where reports of abuse or harassment have gone ignored."
      ]
    }
  ],
  "EU": [
    {
      "country": "UA",
      "title": "'This War Made Him a Monster' Ukrainian Women Fear the Return of Their Partners",
      "link": "https://fullerproject.org/story/ukrainian-women-fear-the-return-of-their-partners/",
      "reporter": "Jessie Williams, in partnership with TIME",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/TFP-Ukraine-Domestic-Violence_3000_2000_SA.jpg",
      "photoCredit": "Illustration by Susie Ang for The Fuller Project",
      "summary": [
        "In Ukraine, women are fleeing violence, but not just by Russian armed forces. An increasing number of Ukrainian troops are returning home changed men, committing horrid acts of domestic violence."
      ]
    },
    {
      "country": "UA",
      "title": "Ukraine’s domestic violence survivors are battling for justice",
      "link": "https://fullerproject.org/story/ukraines-domestic-violence-survivors-are-battling-for-justice/",
      "reporter": "Jessie Williams",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Jessie-Williams_The-Fuller-Project.jpeg",
      "photoCredit": "Jessie Williams/The Fuller Project",
      "summary": [
        "A year after she first reported on rising domestic violence in Ukraine, reporter Jessie Williams finds a worsening situation."
      ]
    },
    {
      "country": "TR",
      "title": "Conservative Muslim Women Helped Erdoğan Win Previous Elections. Now Some Are Turning Against Him",
      "link": "https://fullerproject.org/story/conservative-muslim-women-helped-erdogan-win-previous-elections-now-some-are-turning-against-him/",
      "reporter": "Fariba Nawa, in partnership with TIME",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/8March2022-Havle-group-in-feminist-night-march-02.jpg",
      "photoCredit": "Photo by Milos Bicanski/Getty Images",
      "summary": [
        "The younger generation of pious Turkish women are more educated and more aware of their rights, giving them the power and knowledge to fight patriarchal norms.",
        "The current leadership initially supported women’s rights but is reneging and has teamed up with far right groups to try to remove feminist legislations for things like alimony, abortion and gender-based violence.",
        "The women’s vote, especially among the ruling government’s former supporters, could decide the election, which may go to a runoff."
      ]
    },
    {
      "country": "CH",
      "title": "As heat waves intensify, evidence that older women are hit hardest is growing. Now some are fighting back",
      "link": "https://fullerproject.org/story/as-heat-waves-intensify-evidence-that-older-women-are-hit-hardest-is-growing-now-some-are-fighting-back/",
      "reporter": "Claire Cozens",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Photo-by-Milos-Bicanski_Getty-Images.jpeg",
      "photoCredit": "Michal Fludra/NurPhoto via Getty Images",
      "summary": [
        "As evidence grows that heat waves hit older women hardest, a group of Swiss women are taking their government to court over climate inaction."
      ]
    },
    {
      "country": "GB",
      "title": "‘A wake-up call’: After alleged metaverse rape, calls to protect women and girls grow ",
      "link": "https://fullerproject.org/story/a-wake-up-call-after-alleged-metaverse-rape-calls-to-protect-women-and-girls-grow/",
      "reporter": "Louise Donovan",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Westend61_Getty-Images.jpeg",
      "photoCredit": "Westend61/Getty Images",
      "summary": [
        "Sexual assault and harassment are largely unregulated in virtual reality, despite rising reports of psychological harm caused by rape in the metaverse."
      ]
    }
  ],
  "SAS": [
    {
      "country": "IN",
      "title": "The women workers who are subsidizing global public health",
      "link": "https://fullerproject.org/story/the-women-workers-who-are-subsidizing-global-public-health/",
      "reporter": "Maher Sattar & Shreya Raman, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/AshaWorkers-01260.jpeg",
      "photoCredit": "Abhijeet Gurjar for Foreign Policy and The Fuller Project",
      "summary": [
        "Community health workers, like the famous ASHA workers of India, form the cost-effective backbone of rural health programs around the world and have been praise for their role in fighting the COVID-19 pandemic. But the reason they’re cost-effective is because they’re often unpaid, a fact that donors and nonprofits have conveniently overlooked when drawing up their budgets.",
        "The result is that there are an estimated 6 million female health workers whose unpaid and underpaid labor subsidizes trillions of dollars in global health."
      ]
    },
    {
      "country": "IN",
      "title": "India has made remarkable progress cutting maternal deaths. Could climate change pose a threat?",
      "link": "https://fullerproject.org/story/india-has-made-remarkable-progress-cutting-maternal-deaths-could-climate-change-pose-a-threat/",
      "reporter": "Cheena Kapoor, in partnership with Scroll",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/13.jpeg",
      "photoCredit": "Cheena Kapoor for The Fuller Project",
      "summary": [
        "India has made huge gains in maternal health in recent decades, thanks in large part to increased access to healthcare facilities. The proportion of institutional deliveries has tripled and is now well over 50%. But there are fears that progress could be jeopardized by a climate change-linked water crisis impacting hospitals, which at their worst have led to maternity units being shut during the dry season and having to turn away women in labor."
      ]
    },
    {
      "country": "IN",
      "title": "India’s solar power push delivers an unexpected bonus – empowering rural women",
      "link": "https://fullerproject.org/story/indias-solar-power-push-delivers-an-unexpected-bonus-empowering-rural-women/",
      "reporter": "Disha Shetty, in partnership with Scroll",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Geeta-Devi-Gujjar-in-center-sits-surrounded-by-other-members-of-the-milk-co-operative-Lad-Devi-left-and-Durga-Devi-right_.jpg",
      "photoCredit": "Photo by Rebecca Conway for The Fuller Project",
      "summary": [
        "India aims to meet 50% of its energy needs from clean energy sources by 2030 of which solar will form the largest share.",
        "Women are adopting solar-powered appliances in large numbers as it allows them to run small businesses where they are.",
        "The income is helping women gain financial independence and translating to social change."
      ]
    },
    {
      "country": "PK",
      "title": "‘We have no hope’: What Pakistan’s expulsion of Afghan refugees means for women",
      "link": "https://fullerproject.org/story/we-have-no-hope-what-pakistans-expulsion-of-afghan-refugees-means-for-women/",
      "reporter": "Zahra Nader",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-1763977251.jpeg",
      "photoCredit": "Photo by BANARAS KHAN/AFP via Getty Images",
      "summary": [
        "With nearly 400,000 Afghans forced to leave Pakistan in recent months, women and girls who return to their homeland face serious threat."
      ]
    }
  ],
  "MEA": [
    {
      "country": "AF",
      "title": "Afghan women take their own lives as despair grows under Taliban rule",
      "link": "https://fullerproject.org/story/afghan-women-take-their-own-lives-as-despair-grows-under-taliban-rule/",
      "reporter": "Zahra Nader & Zan Times Reporters, in partnership with The Guardian",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/AfghanWomen.jpg",
      "photoCredit": "For Zan Times and The Fuller Project",
      "summary": [
        "The removal of their hard-won freedoms under the Taliban has led to a mental health crisis among Afghan women - what UN Women’s representative has termed a \"mental health crisis precipitated by a women’s rights crisis.\"",
        "Globally, men are more than twice as likely as women to die by suicide. In Afghanistan, unofficial data collected from hospitals indicates many more women are now taking their own lives.",
        "Afghan activists, international aid agencies and United Nations experts say the high rate of female suicides in Afghanistan reflects not only a loss of freedom for women, but an increase in forced marriages and domestic abuse - and a loss of hope."
      ]
    },
    {
      "country": "AF",
      "title": "Women protesters in Afghanistan call for aid groups to serve Taliban an ultimatum",
      "link": "https://fullerproject.org/story/women-protesters-call-for-afghanistan-ultimatum/",
      "reporter": "Zahra Joya",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Photo-by-Scott-Peterson_Getty-Images.jpg",
      "photoCredit": "Photo by Scott Peterson/Getty Images",
      "summary": [
        "Protesters say U.N. should withdraw aid from Afghanistan rather than give in to Taliban ban on women workers."
      ]
    },
    {
      "country": "AF",
      "title": "Reporter’s Notebook: As suicides rise in Afghanistan, getting people to open up under the Taliban poses enormous challenges",
      "link": "https://fullerproject.org/story/reporters-notebook-afghan-women-turn-to-suicide/",
      "reporter": "Zahra Nader",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/For-Zan-Times-and-The-Fuller-Project.jpeg",
      "photoCredit": "For Zan Times and The Fuller Project",
      "summary": [
        "News stories about Afghan women dying by suicide made Zahra Nader want to dig deeper. Getting people to open up took months."
      ]
    },
    {
      "country": "LB",
      "title": "The Middle East Has a ‘Sextortion’ Problem",
      "link": "https://fullerproject.org/story/the-middle-east-has-a-sextortion-problem/",
      "reporter": "Katherine Hashed Mozqer, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Sextortion.jpeg",
      "photoCredit": "Leo Patrizi/Getty Images",
      "summary": [
        "Deep-rooted patriarchal traditions have made women in the Middle East and North Africa particularly vulnerable to sextortion, whereby victims are tricked or coerced into sharing photos that the perpetrator threatens to make public.",
        "The U.S. Federal Bureau of Investigation and its international law enforcement agency warned this year that sextortion is becoming a global crisis.",
        "While the bulk of cases are never reported to authorities, a 2019 survey by Transparency International found that one in five people polled in Jordan, Lebanon, and Palestine had experienced sextortion or knew someone who had—among the worst rates in the world."
      ]
    },
    {
      "country": "PS",
      "title": "Gaza’s Widows Are Fighting for Their Families’ Lives",
      "link": "https://fullerproject.org/story/gazas-widows-are-fighting-for-their-families-lives/",
      "reporter": "Neha Wadekar, in partnership with Foreign Policy",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-1729685927.jpeg",
      "photoCredit": "Photo by Ahmad Hasaballah/Getty Images",
      "summary": [
        "The war in Gaza has killed more than 21,100 Palestinians, an estimated 70 percent of them women and children.",
        "For the women who do survive, thousands have been widowed or become the heads of their households, taking on responsibilities outside the home for the first time in their lives.",
        "The burden of caring for their families, compounded with the trauma of the conflict, is affecting the mental health of these women, who lack."
      ]
    },
    {
      "country": "PS",
      "title": "From bombings to blackouts — why the story of Gaza’s war widows was a reporting challenge like no other",
      "link": "https://fullerproject.org/story/from-bombings-to-blackouts-why-the-story-of-gazas-war-widows-was-a-reporting-challenge-like-no-other/",
      "reporter": "Neha Wadekar",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/Photo-by-Ahmad-Hasaballah_Getty-Images.jpeg",
      "photoCredit": "Photo by Ahmad Hasaballah/Getty Images",
      "summary": [
        "Our reporters talk about the unique challenges they faced to tell the stories of Gaza’s war widows."
      ]
    },
    {
      "country": "AE",
      "title": "COP28: How climate change hits women and the world of work",
      "link": "https://fullerproject.org/story/cop28-how-climate-change-hits-women-and-the-world-of-work/",
      "reporter": "Louise Donovan",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/cop28-Photo.jpg",
      "photoCredit": "Photo by Frédéric Soltan/Corbis via Getty Images",
      "summary": [
        "With scientists declaring 2023 likely to be the hottest year ever recorded, discussions at this year’s COP28, the annual U.N. climate summit, have never felt more urgent."
      ]
    },
    {
      "country": "IR",
      "title": "Iran’s New—Even Worse—Hijab Era Has Begun",
      "link": "https://fullerproject.org/story/irans-new-even-worse-hijab-era-has-begun/",
      "reporter": "Saqi Nassiri & Tooba Moshiri",
      "coverPhoto": "https://fullerproject.org/wp-content/uploads/2024/03/GettyImages-2033876320.jpg",
      "photoCredit": "Photo by HOSSEIN BERIS/Middle East Images/AFP via Getty Images",
      "summary": [
        "Following widespread anti-government protests in 2022, Iranian authorities have ramped up a crackdown on women who flout the country’s strict hijab regulations.",
        "In addition to tougher enforcement of existing rules, a recently-approved draft law would increase punishments for women who do not wear the hijab properly - with U.N. experts and rights advocates warning that this could further erode female freedoms, and even lead to ‘gender apartheid’.",
        "The hijab is expected to be a big issue ahead of upcoming elections, and analysts fear the general outlook for women in Iran could soon deteriorate further if conservatives consolidate their grip on power."
      ]
    }
  ]
}

export default data;
